import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type { AssetDetailResponse } from '@/entities/asset-search/domain/types';

export type CompareRunsParams = {
  runIds: number[];
};

export type CompareRunsResponse = {
  runs: AssetDetailResponse[];
};

export const compareRuns = async ({ runIds }: CompareRunsParams): Promise<CompareRunsResponse> => {
  const { data } = await cycloneApiClient.get<CompareRunsResponse>('/runs/compare', {
    params: {
      runIds,
    },
  });
  return data;
};
